import React from "react";
import { useForm } from "react-hook-form";
import { Button, TextAreaController, Text } from "@pushpress/shared-components";
import PanelModal from "../PanelModal";

export interface SendTextForm {
  message: string;
}

export interface SendTextModalModalProps {
  title: string;
  message?: string;
  clarifyingText?: string;
  loading?: boolean;
  visible: boolean;
  onClose: VoidFunction;
  onSendClick: (values: SendTextForm) => void;
}

function SendTextModalModal(props: SendTextModalModalProps) {
  const { visible, onClose } = props;

  return (
    <PanelModal visible={visible} onClose={onClose}>
      <SendTextModalModalContent {...props} />
    </PanelModal>
  );
}

function SendTextModalModalContent(props: SendTextModalModalProps) {
  const { title, message, clarifyingText, onSendClick, loading } = props;

  const { control, handleSubmit, watch, setError } = useForm<SendTextForm>();

  // Watch the message field for live character counting
  const messageValue = watch("message") || "";
  const charCount = messageValue.length;
  const isAtLimit = charCount >= 160;

  const handleFormSubmit = (data: SendTextForm) => {
    // Validate message length before submission
    if (data.message.length > 160) {
      setError("message", { message: "Message cannot exceed 160 characters" });
      return;
    }
    onSendClick(data);
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <PanelModal.Header title={title} />
      <PanelModal.Body message={message}>
        {clarifyingText && (
          <Text
            component="p"
            variant="body-sm"
            color="wolf-600"
            className="mb-4"
          >
            {clarifyingText}
          </Text>
        )}
        <TextAreaController
          label="Message"
          control={control}
          name="message"
          required
          rows={9}
          defaultValue=""
          maxLength={160}
        />
        {isAtLimit && (
          <Text variant="body-sm" color="wild-watermellon-400" className="mt-1">
            {"Message cannot exceed 160 characters."}
          </Text>
        )}
      </PanelModal.Body>
      <PanelModal.Footer>
        <Button
          text="Send"
          buttonType="primary"
          loading={loading}
          type="submit"
          disabled={loading || isAtLimit}
        />
      </PanelModal.Footer>
    </form>
  );
}

export default SendTextModalModal;
